import React from 'react';
import SubHeader from '../components/Subheader/Subheader';
import JobListAccordionComp from "../components/JobListAccordion";
import {Homeownerlist} from "../components/JobListAccordion/Homeownerlist"
import {
  TextField,
  Grid,

  InputAdornment,
  Icon,
} from "@mui/material";


const Homeowner = () => {
   const HomeownerOptions = [
   
    { value: 'New to Old', label: 'New to Old'},
    { value: 'Old to New', label: 'Old to New'},
]
    return (
        <Grid>
           <SubHeader name="Home Owners" options={HomeownerOptions}/>
           <Grid sx={{

            display:'flex',
           
          marginTop:'22px',
           
           }}>
<Grid sx={{color:'#000000',fontWeight:'600',fontFamily: 'Rubik',fontSize:'16px',width:'33%'}}>User Name</Grid>
  <Grid sx={{color:'#000000',fontWeight:'600',fontFamily: 'Rubik',fontSize:'16px',width:'33%'}}>Mobile Number</Grid>
  <Grid sx={{color:'#000000',fontWeight:'600',fontFamily: 'Rubik',fontSize:'16px',width:'33%',marginLeft:'auto'}}>Email</Grid>

           </Grid>
           <JobListAccordionComp
        // JobQuoteList={JobQuoteList}
        //JobStatus={status}   
         Accordianlist={Homeownerlist}

        Pagename={'Homeowner'}      
      ></JobListAccordionComp >
        </Grid>
    );
};

export default Homeowner;